


















import { Component, Vue, Watch } from "vue-property-decorator";
import AssetForm from "trade/components/fiat_trade/AssetForm.vue";
import { ATMAsset, C2COffer } from "@foxone/api/src/models/market";
import BigNumber from "bignumber.js";

@Component({
  components: {
    AssetForm
  },
  inheritAttrs: false
})
class C2CPage extends Vue {
  lock = false;

  fiatErrorMessage = "";

  fiatValue = "";

  fiatAsset: any = null;

  wantedValue = "";

  wantedAsset: ATMAsset | null = null;

  get offer() {
    const { fiatAsset, wantedAsset } = this;
    if (!fiatAsset || !wantedAsset) return null;
    const offers: C2COffer[] = this.$store.state.trade.offers;
    const offer = offers.find(
      offer =>
        offer.fiat_symbol === fiatAsset.symbol &&
        offer.asset_id === wantedAsset.asset_id
    );
    return offer || null;
  }

  get tips() {
    const tips: any = [];
    const { fiatAsset, wantedAsset, offer } = this;
    if (this.fiatErrorMessage) {
      tips.push({
        text: this.fiatErrorMessage,
        hide: !this.fiatErrorMessage,
        error: true
      });
    }
    if (offer && wantedAsset && fiatAsset) {
      tips.push({
        text:
          `${this.$t("common.current-rate")}:` +
          `1 ${wantedAsset.symbol}  ≈ ${offer.price} ${fiatAsset.symbol}`
      });
      if (+offer.max_fiat > +offer.min_fiat) {
        tips.push({
          text: this.$t("common.amount.limit", {
            min: offer.min_fiat + " " + fiatAsset.symbol,
            max: offer.max_fiat + " " + fiatAsset.symbol
          })
        });
      }
    }
    return tips;
  }

  get estimatedRate() {
    return this.offer && this.offer.price;
  }

  @Watch("fiatValue")
  @Watch("wantedAsset")
  handleOfferAmountChange() {
    if (this.lock) {
      this.lock = false;
      return;
    }
    if (!this.wantedAsset) {
      this.wantedValue = "";
      return;
    }
    if (this.fiatValue === "") {
      this.wantedValue = "";
      return;
    }
    if (!this.estimatedRate) return;
    const precision = Math.min(this.wantedAsset.precision + 4, 8);
    const amount =
      this.$common.utils.number.toPrecision(
        +this.fiatValue / +this.estimatedRate,
        precision
      ) + "";
    if (amount !== this.wantedValue) {
      this.lock = true;
    }
    this.wantedValue = amount;
  }

  @Watch("wantedValue")
  @Watch("fiatAsset")
  handleWantAmountChange() {
    if (this.lock) {
      this.lock = false;
      return;
    }
    if (!this.fiatAsset) {
      this.fiatAsset = "";
      return;
    }
    if (this.wantedValue === "") {
      this.fiatValue = "";
      return;
    }
    if (!this.estimatedRate) return;
    const precision = this.fiatAsset.precision;
    const amount =
      this.$common.utils.number.toPrecision(
        +this.wantedValue * +this.estimatedRate,
        precision,
        BigNumber.ROUND_CEIL
      ) + "";
    if (amount !== this.fiatValue) {
      this.lock = true;
    }
    this.fiatValue = amount;
  }

  @Watch("fiatValue")
  handleFiatChange() {
    setTimeout(() => {
      const form: any = this.$refs.form;
      if (!form) return;
      this.fiatErrorMessage = form.inputs[0].messagesToDisplay[0];
    }, 200);
  }

  handleSubmit() {
    if (!this.wantedAsset) return;
    const form: any = this.$refs.form;
    const valid = form.validate();
    if (valid) {
      this.$emit("submit", {
        fiatValue: this.fiatValue,
        fiatAssetId: this.fiatAsset.asset_id,
        wantedAssetId: this.wantedAsset.asset_id
      });
    }
  }
}
export default C2CPage;
